import type { GetTweets200PageAllOfThreeContentItemAuthorBasicInfo } from './getTweets200PageAllOfThreeContentItemAuthorBasicInfo';
import type { GetTweets200PageAllOfThreeContentItemAuthorSocial } from './getTweets200PageAllOfThreeContentItemAuthorSocial';

/**
 * 트윗 작성자 정보
 */
export type GetTweets200PageAllOfThreeContentItemAuthor = {
  /** 사용자 기본 정보 */
  basicInfo: GetTweets200PageAllOfThreeContentItemAuthorBasicInfo;
  /** 소셜 관계 정보 */
  social?: GetTweets200PageAllOfThreeContentItemAuthorSocial;
};
